
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon icon-tabler icons-tabler-outline icon-tabler-timeline",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","stroke":"none"}}),_c('path',{attrs:{"d":"M4 16l6-7 5 5 5-6"}}),_c('path',{attrs:{"d":"M14 14a1 1 0 102 0 1 1 0 10-2 0M9 9a1 1 0 102 0 1 1 0 10-2 0M3 16a1 1 0 102 0 1 1 0 10-2 0M19 8a1 1 0 102 0 1 1 0 10-2 0"}})])
          )
        }
      }
    